import theme from "../../../js/shared/new-theme";

const palette = theme.palette;

export const defaultStyle = (withShadow, hasError) => {
    return `
        > div { 
            button {
                & span {
                    background-color: ${palette.common.white};
                    color: ${hasError ? palette.red[600].value : palette.gray[600].value};
                    border-color ${hasError ? palette.red[400].value : palette.gray[400].value};
                }

                & i {
                    color: ${hasError ? palette.red[600].value : palette.gray[600].value};
                }
            }

            > div {
                background-color: ${palette.common.white} !important;
                border-color: ${hasError ? palette.red[400].value : palette.gray[400].value} !important;
            }
        }
    `;
};
